import React, { Suspense, lazy } from 'react';
import './index.scss';
import Header from '../Header';
import { Route, Routes } from 'react-router';
import Home from '../pages/Home';
import Blog from '../pages/Blog';
import Donate from '../pages/Donate';
import Projects from '../pages/Projects';
import AboutUs from '../pages/AboutUs';
import Contact from '../pages/Contact';

import headerHome from '../../assets/header-home.jpg';
import headerProjects from '../../assets/header-projects.jpg';
import headerContact from '../../assets/header-contact.jpg';

// Staff-only, so its QR library never reaches a visitor's bundle.
const DonateQr = lazy(() => import('../pages/DonateQr'));

function Site() {
    return (
        <div className="app">
            <Header links={[
                { label: "HOME", to: "/", image: headerHome },
                { label: "BLOG", to: "/blog", image: headerProjects },
                { label: "DONEREN", to: "/donate", image: headerProjects },
                { label: "NIEUWSBRIEF", to: "https://sibforms.com/serve/MUIFAOx9LAWejz3_nJktOca5X-G0H8APuwATrmJ4Iu-N-c9_LytxkAD3FZHqmk98mj4HqwYtgwEVWf6WHFLG4srpxpzO8ER77PrVMgt2uCjyG2VOoGlmw-Rdigu8Wm9rk0LPFPRIafGDITvgrnJtfgmMPngSkogNbvFSJ_bdPz6PmZRAf568r0sS725Gc_UsXsk79SQJgY2pGDLT", image: headerProjects },
                { label: "PROJECTEN", to: "/projects", image: headerProjects },
                { label: "OVER ONS", to: "/about", image: headerContact },
                { label: "CONTACT", to: "/contact", image: headerContact },
            ]} />

            <div className="app-body">
                <Routes>
                    <Route path='/*' element={<Home />} />
                    <Route path='/blog/*' element={<Blog />} />
                    <Route path='/donate' element={<Donate />} />
                    <Route path='/projects' element={<Projects />} />
                    <Route path='/about/*' element={<AboutUs />} />
                    <Route path='/contact' element={<Contact />} />
                </Routes>
            </div>

            <footer className='app-footer' />
        </div>
    );
}

function App() {
    return (
        <Routes>
            {/* Held out for someone to scan, so it skips the site chrome entirely. */}
            <Route path='/qr' element={<Suspense fallback={null}><DonateQr /></Suspense>} />
            <Route path='/*' element={<Site />} />
        </Routes>
    );
}

export default App;
 